const QuoteCarousel = {
    init() {
        if ( !window.tinySlider ) {
            return;
        }
        $('.js-quote-carousel').each( (_, el) => {
            const $control_icon = '<svg height="34" height="34" viewBox="0 0 34 34" width=".5in" xmlns="http://www.w3.org/2000/svg"><g fill="#041e42" fill-rule="evenodd"><path d="m17 0c-9.4 0-17 7.6-17 17s7.6 17 17 17 17-7.6 17-17-7.6-17-17-17zm0 31.7c-3.9 0-7.7-1.6-10.4-4.3-2.8-2.8-4.3-6.5-4.3-10.4s1.6-7.7 4.3-10.4c2.8-2.8 6.5-4.3 10.4-4.3 8.1 0 14.7 6.6 14.7 14.7s-6.6 14.7-14.7 14.7z"/><path d="m24.6 16.2-4.5-4.5-.8-.8-1.6 1.6.8.8 2.6 2.6h-12v2.2h12l-2.6 2.6-.8.8 1.6 1.6.8-.8 4.5-4.5.8-.8z"/></g></svg>'
            const $$ = $(el);
            const $items = $$.find('.js-carousel-item');
            if ( $items.length > 1 ) {
                tinySlider({
                    container: $$.get(0),
                    autoplay: true,
                    controls: true,
                    nav: false,
                    items: 1,
                    controlsText: [$control_icon + '<span class="u-sr-only ">Prev</span>', $control_icon + '<span class="u-sr-only ">Next</span>'],
                });
            }
        })
    },
};
$(QuoteCarousel.init.bind(QuoteCarousel));
